import React from 'react'
import * as Comp from './coachmark.styles.ts'
import type { TCoachmarkProps } from './types/index.ts'
import { CoachmarkContent } from './components/coachmark-content/index.tsx'
import { CoachmarkWrapper } from './components/coachmark-wrapper/index.tsx'
import { useCoachmarkLayout } from './hooks/useCoachmarkLayout.ts'
import {
  PositionAlignment,
  PositionDirection,
} from '~/utils/layout/position-enums'

const CoachmarkRoot = ({
  isOpen,
  title,
  description,
  totalStep,
  currentStep,
  onPrevious = () => {},
  onNext = () => {},
  onClose = () => {},
  tag,
  side = PositionDirection.TOP,
  align = PositionAlignment.MIDDLE,
  autoPosition = true,
  children,
  ...rest
}: TCoachmarkProps) => {
  const { rootLayout, isLayoutReady, rootRef, handleLayout } =
    useCoachmarkLayout({
      isOpen,
    })

  const renderChildren = React.Children.map(children, child => {
    if (!React.isValidElement(child)) return null

    if (child.type === CoachmarkContent) {
      return React.cloneElement(child, {
        ...child.props,
        isOpen,
        title,
        description,
        totalStep,
        currentStep,
        onPrevious,
        onNext,
        onClose,
        tag,
        rootLayout,
        rootLayoutReady: isLayoutReady,
        side,
        align,
        autoPosition,
      })
    }

    return child
  })

  return (
    <Comp.Root ref={rootRef} {...rest} onLayout={handleLayout}>
      {renderChildren}
    </Comp.Root>
  )
}

export const Coachmark = {
  Root: CoachmarkRoot,
  Wrapper: CoachmarkWrapper,
  Content: CoachmarkContent,
}

export type { TCoachmarkProps }
export { PositionAlignment, PositionDirection }
